import adminLayout from '@/admin/layouts/LayoutOne.vue'

export default [
    {
        path: '/leave/requests',
        name: 'LeaveRequestManagement',
        component: () => import('@/admin/modules/leave/LeaveRequestManagement'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/leave/balance',
        name: 'LeaveBalance',
        component: () => import('@/admin/modules/leave/LeaveBalance'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/leave/policies',
        name: 'LeavePolicy',
        component: () => import('@/admin/modules/leave/policy/LeavePolicy'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/leave-balance',
        name: 'EmployeeLeaveBalance',
        component: () => import('@/admin/modules/leave/EmployeeLeaveBalance'),
        meta: { layout: adminLayout, requiresAuth:true }
    }
];